module.exports = __webpack_public_path__ + "static/img/5997fedcc7bd4cffbd350b40d1b5b987.c47ea580.jpg";